module.exports = __webpack_public_path__ + "static/media/wordguesserTextImage.80772e00.png";